import styled from 'styled-components';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  min-height: 127.6px;
  background: white;
  border: 0.5px solid ${(p) => p.theme?.colors?.borderNeutralLighter ?? '#bababa'};
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    border-color: ${(p) => p.theme?.colors?.borderNeutralDefault ?? '#e0e0e0'};
  }
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
  flex-shrink: 0;
`;

export const TitleLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  min-width: 0;
  flex: 1;
`;

/** Typography from @ann/web-components renders a span; ellipsis must be on that span. */
export const TitleTextWrap = styled.div`
  min-width: 0;
  overflow: hidden;
  display: flex;

  & > span {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const SeparatorDot = styled.span`
  color: #99a1af;
  font-size: 14px;
  flex-shrink: 0;
`;

export const SectionPath = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  min-width: 0;
`;

export const SectionPathText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${(p) => p.theme?.colors?.textBody ?? '#5c5c5c'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TitleRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const DescriptionBox = styled.div`
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid ${(p) => p.theme?.colors?.borderPrimarySubtle ?? '#e9f1ff'};
  border-radius: 8px;
  padding: 4px 8px;
  width: 100%;
  flex-shrink: 0;
`;

export const DescriptionText = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${(p) => p.theme?.colors?.textSubtitle ?? '#2a2a2a'};
  line-height: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

export const MetadataRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  flex-shrink: 0;
`;

export const MetaPill = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 4px 8px;
  background: rgba(250, 250, 250, 0.6);
  border: 1px solid ${(p) => p.theme?.colors?.borderNeutralSubtle ?? '#f2f2f2'};
  border-radius: 8px;
  flex-shrink: 0;
`;

export const MetaSeparator = styled.span`
  color: ${(p) => p.theme?.colors?.surfaceNeutralEmphasis ?? '#d9d9d9'};
  font-size: 16px;
  flex-shrink: 0;
`;

export const MetaGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const MetaText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${(p) => p.theme?.colors?.textBody ?? '#5c5c5c'};
  white-space: nowrap;
`;

export const TagsArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  flex-shrink: 1;
  min-width: 0;
`;

export const TagTooltipTrigger = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;
